<div class="accordion" id="filterAccordion">
    <div class="accordion-item">
        <h2 class="accordion-header">
            <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
                aria-expanded="true" aria-controls="collapseOne">
                <i class="fa-solid fa-filter pe-2" *ngIf="!searchCriteriaDirty"></i> 
                <i class="fa-solid fa-filter-circle-xmark" *ngIf="searchCriteriaDirty"></i>
                Filtri
            </button>
        </h2>
        <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#filterAccordion" #filterAccordion>
            <div class="accordion-body">
                <ng-container [ngTemplateOutlet]="fields" [ngTemplateOutletContext]="context"></ng-container>
            </div>
        </div>
        <div *ngIf="searchCriteriaDirty">
            <i class="fa-solid fa-circle-info"></i><span
                class=" ms-1 fs-6 fw-lighter fst-italic text-danger">Attenzione! Filtri attivi.</span>
        </div>
    </div>
</div>